// extracted by css-extract-rspack-plugin
export default {"root":"TcDf9effIVUOfHKv"};